import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  ResponsiveContainer,
  Legend,
} from "recharts";

import {
  metrics,
  messages,
  categoryColors,
  getYAxisTicks,
  getCategory,
  TestMap, getMaxScore
} from "./BarChartUtils";

export const MentalHealthTest = ({ TestName, Score }) => {
  // const currCategory = getCategory(TestName, 13);
  //   console.log(currCategory);
  //   console.log(categoryColors[currCategory.key]);
  const yAxisTicks = getYAxisTicks(TestName);
  //   console.log(yAxisTicks);
  const widthPerBar = 80;
  const minWidth = 384;
  const dynamicWidth = Math.max(minWidth, Score.length * widthPerBar);

  // For print, use a more conservative width calculation
  const printWidth = Math.min(dynamicWidth, 600); // Cap at 600px for print
  const lastElement = Score[Score.length - 1];
  //   console.log(lastElement.value);
  let lastScore = lastElement.value;
  const lastScoreCategory = getCategory(TestName, lastScore);
  //   console.log(lastScoreCategory.key);
  const status = lastScoreCategory.key;
  //   console.log(TestName);
  //   console.log(messages.Anxiety[status]);
  const lastScoreMessage = messages[TestName][status];
  //   console.log(lastScoreMessage);
  lastScore = lastScore.toString();
  if (lastScore.length == 1) {
    lastScore = "0" + lastScore;
  }

  // Month abbreviation map and formatter for X-axis labels
  const monthAbbrev = {
    January: "Jan",
    February: "Feb",
    March: "Mar",
    April: "Apr",
    May: "May",
    June: "Jun",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Dec",
  };
  const formatMonthShort = (label) => {
    if (typeof label !== "string") return label;
    const [maybeMonth, ...rest] = label.split(" ");
    const short = monthAbbrev[maybeMonth] || maybeMonth;
    return [short, ...rest].join(" ");
  };
  const maxScore = getMaxScore(TestName);

  return (
    <div
      className="overflow-x-visible w-full print:w-full print:max-w-none"
      style={{
        width: `${dynamicWidth}px`,
        "--print-width": `${printWidth}px`,
      }}
    >
      <div className="font-bold text-black text-xl text-left pl-2">
        {TestMap[TestName]}
      </div>
      <div className="flex gap-2 pb-2 pt-2 pl-2">
        {/* score and score meaning */}
        <p className="text-green-600 font-extrabold text-lg">{lastScore}</p>
        <p className="text-green-600 text-lg">{lastScoreMessage}</p>
      </div>
      <div className="mb-2"></div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          // width={300}
          // height={300}
          data={Score}
          margin={{
            top: 10,
            right: 20,
            left: 65,
            bottom: 5,
          }}
        >
          <XAxis
            axisLine={false}
            tickLine={false}
            dataKey="date"
            interval={0}
            tick={{ fontSize: 12 }}
            tickFormatter={formatMonthShort}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            type="number"
            ticks={yAxisTicks}
            tick={{ fontSize: 12 }}
            domain={[0, maxScore+2]}
            tickFormatter={(score) => {
              const category = getCategory(TestName, score);
              return category.key;
            }}
          />

          <Bar barSize={35} dataKey="value" radius={[10, 10, 0, 0]}>
            {Score.map((entry, index) => {
              const category = getCategory(TestName, entry.value);
              const color = categoryColors[category.key] || "gray";

              return <Cell key={`cell-${index}`} fill={color} />;
            })}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
